var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNinja = function SvgNinja(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10v8a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zm6.5 0a1.5 1.5 0 0 0 0-3 1.5 1.5 0 0 0 0 3zm7 0a1.5 1.5 0 0 0 0-3 1.5 1.5 0 0 0 0 3z"
  })));
};
export default SvgNinja;